import { CustomAvatar } from '@/components/avatar/Avatar';
import { InfoBox } from '@/components/infoBox/InfoBox';
import { theme } from '@/styles/theme';
import { capitalizeFirstLetterOfEachWord } from '@/utils/getInitials';
import { Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';

interface Appointment {
  id: string;
  patientName: string;
  avatar: string;
  date: string;
  time: string;
}
export const AppointmentCard = ({
  appointment,
  onViewDetails,
}: {
  appointment: Appointment;
  onViewDetails: (appointmentId: string) => void;
}) => {
  const { t } = useTranslation('common');

  return (
    <Box sx={styles.header}>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <CustomAvatar
            name={appointment.patientName}
            src={appointment.avatar}
          />
          <Box>
            <Typography sx={styles.headerTitle}>{t('patient_name')}</Typography>
            <Typography sx={styles.headerName}>
              {capitalizeFirstLetterOfEachWord(appointment.patientName)}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ mb: -2 }}>
          <InfoBox
            iconLeft={<EventOutlinedIcon sx={styles.iconLeft} />}
            title={t('date_and_time')}
            text={appointment.date}
            subText={`às ${appointment.time}`}
          />
        </Box>
      </Box>
      <Box>
        <IconButton onClick={() => onViewDetails(appointment.id)}>
          <ArrowForwardIosOutlinedIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

const styles = {
  header: {
    padding: 1.3,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
  },
  headerTitle: {
    color: '#4f4f4f',
    fontSize: '1.2rem',
    fontWeight: 600,
  },
  headerName: {
    color: '#000',
    fontSize: '1.4rem',
  },
  iconLeft: {
    fontSize: '2rem',
    marginLeft: -2,
    marginRight: 2,
  },
};
